import { format, getMonth, getYear } from 'date-fns';

export type dateToQuarterProps = {
  quarter: number;
  year: number;
};

/**
 * Transforms the date in Quarters
 * @param date - The date (10-03-2025)
 * @returns The date in Quarters {quarter: 1, year: 2025}
 */
export const dateToQuarter = (date?: string): dateToQuarterProps | undefined => {
  if (date) {
    const month = getMonth(date) + 1;
    const year = getYear(date);
    const quarter = Math.ceil(month / 3);

    return {
      quarter: quarter,
      year: year,
    };
  }

  return undefined;
};

/**
 * Formats a date string to an exact format
 * @param date - The date string to format
 * @param fallback - The fallback value if the date is undefined or null
 * @returns The formatted date string or the fallback value
 */
export const exactDateFormatter = (date: string | undefined | null, fallback: string) => {
  if (!date) return fallback;
  return format(date, 'dd-MM-yyyy');
};

/**
 * Formats a date string to a quarter format
 * @param date - The date string to format
 * @param fallback - The fallback value if the date is undefined or null
 * @returns The formatted date string or the fallback value
 */
export const quarterDateFormatter = (date: string | undefined | null, fallback: string) => {
  if (!date) return fallback;

  const dateQuarter = dateToQuarter(date);
  return dateQuarter ? `${dateQuarter.quarter}e kwartaal van ${dateQuarter.year}` : fallback;
};
